import { RowActions } from '@app/components/table/RowActions';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ShowOnStreamAction } from '@app/modules/audit/components/ShowOnStreamAction';
import { AuditMatch } from '@app/modules/audit/modules/station-audit/types';
import { Box } from '@mui/material';

interface ScheduleStatusSpotDetailMatchActionsProps {
  match: AuditMatch;
}

/**
 * Row actions for an unmatched airing in the detail dialog (logger stream at match time).
 */
export function ScheduleStatusSpotDetailMatchActions({
  match,
}: ScheduleStatusSpotDetailMatchActionsProps) {
  const station = useActiveStation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <RowActions>
        <ShowOnStreamAction
          station={station.slug}
          datetime={match.datetime}
          durationMs={match.playedDuration}
          tab="audiomatches"
        />
      </RowActions>
    </Box>
  );
}
